import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { logAnalyticsEvent } from "../lib/firebase/firebase";
import { observeVisit } from "../lib/metrics/track";
import { useAuth } from "../context/AuthContext";

const FirebaseAnalytics = () => {
    const location = useLocation();
    const { user } = useAuth();

    useEffect(() => {
        observeVisit();
        const onVisible = () => { if (document.visibilityState === 'visible') observeVisit(); };
        document.addEventListener('visibilitychange', onVisible);
        return () => document.removeEventListener('visibilitychange', onVisible);
    }, [location.pathname, user?.uid]);
    
    useEffect(() => {
        const handleTitleChange = () => {
            const pageTitle = document.title;
            logAnalyticsEvent('page_view', { page_title: pageTitle, page_path: location.pathname });
        };

        // Adicione um listener para monitorar mudanças no título da página
        const titleObserver = new MutationObserver(handleTitleChange);
        titleObserver.observe(document.querySelector('title'), { subtree: true, characterData: true, childList: true });

        // Certifique-se de chamar handleTitleChange uma vez no carregamento inicial
        handleTitleChange();

        // Retorne uma função de limpeza para remover o observador quando o componente for desmontado
        return () => {
            titleObserver.disconnect();
        };
    }, []);

    return null;
}

export default FirebaseAnalytics
